// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__23IKB","signatureBlock":"Footer_signatureBlock__130XH","signature":"Footer_signature__L8CSi"};